import { Icon } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import style from "./style.module.css";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * @param {Object} props
 * @param {React.Component} props.icon
 * @param {String} props.title
 * @param {String} props.href
 * @param {React.Component} props.children
 * @returns
 * @example
 *
 * - single item:
 * <AsideItem
 *   icon={HomeIcon}
 *   title="Dashboard"
 *   href="/pbo/dashboard"
 *   {...{ shrunk }}
 * />
 *
 * - item with collapse:
 * <AsideItem
 *   icon={WebIcon}
 *   title="Páginas"
 *   {...{ shrunk }}
 * >
 *  <AsideItem
 *    icon={SecurityIcon}
 *    title="Política de Privacidade"
 *    href="/pbo/pages/privacy"
 *    {...{ shrunk }}
 *  />
 *  <AsideItem
 *    icon={GavelIcon}
 *    title="Termos de Uso"
 *    href="/pbo/pages/terms"
 *    {...{ shrunk }}
 *  />
 * </AsideItem>
 **/
const AsideItem = ({ icon, title, children = null, href, shrunk }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const ref = useRef(null);

  const [open, setOpen] = useState(false);
  const [height, setHeight] = useState(0);
  const [this_route, setThisRoute] = useState(false);

  useEffect(() => {
    // get collapse height
    setHeight(ref?.current?.scrollHeight);
  }, []);

  useEffect(() => {
    // check if this route is active to set background color
    if (location.pathname.replace("/admin/", "") === href) {
      setThisRoute(true);
    } else {
      setThisRoute(false);
    }
  }, [location]);

  const handleOpenCollapse = (e) => {
    setOpen(!open);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        padding: "0 1rem",
      }}
    >
      <div
        className={style.asideItem}
        style={{
          backgroundColor: open ? "#e4e7eb" : "#fff",
          borderRadius: open ? "0.5rem 0.5rem 0 0" : "0.5rem",
          ...(this_route && { backgroundColor: "rgba(var(--accent-color1), 1)" }),
        }}
        onClick={
          children
            ? handleOpenCollapse
            : () => {
                navigate("/admin/" + href);
              }
        }
      >
        <Icon
          style={{
            fontSize: "1.5rem",
            color: this_route ? "#fff" : "black",
          }}
          component={icon}
        />

        <span
          style={{
            fontSize: shrunk ? "0" : "1rem",
            marginLeft: "0.6rem",
            transition: "0.3s ease-in-out",
            color: this_route ? "#fff" : "black",
            fontWeight: this_route ? "600" : "normal",
          }}
        >
          {title}
        </span>

        {children && (
          <Icon
            style={{
              fontSize: "2rem",
              marginLeft: "auto",
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
              transition: "0.3s ease-in-out",
            }}
            component={ArrowDropDownIcon}
          />
        )}
      </div>

      {children && (
        <div
          ref={ref}
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            maxHeight: open ? height + 16 : 0,
            overflow: "hidden",
            transition: "0.3s ease-in-out",
            opacity: open ? 1 : 0,
            backgroundColor: open ? "#e4e7eb" : "transparent",
            borderRadius: "0 0 0.5rem 0.5rem",
            paddingBottom: open ? "1rem" : 0,
            gap: "0.4rem",
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default AsideItem;
